const mapping = {
  makes: {
    'rolls-royce': 'rolls-royce',
    'mercedes-benz': 'mercedes-benz'
  },
  models: {
    'e-tron': 'e-tron',
    'e-tron-gt': 'e-tron gt',
    'e-tron-s': 'e-tron s',
    'q4-e-tron': 'q4 e-tron',
    'rs-e-tron-gt': 'rs e-tron gt',
    'r-type': 'r-type',
    'c-crosser': 'c-crosser',
    'c-zero': 'c-zero',
    'b-max': 'b-max',
    'c-max': 'c-max',
    'focus-c-max': 'focus c-max',
    'grand-c-max': 'grand c-max',
    'mustang-mach-e': 'mustang mach-e',
    's-max': 's-max',
    'cr-v': 'cr-v',
    'cr-x': 'cr-x',
    'cr-z': 'cr-z',
    'fr-v': 'fr-v',
    'hr-v': 'hr-v',
    'd-max': 'd-max',
    'e-pace': 'e-pace',
    'e-type': 'e-type',
    'f-pace': 'f-pace',
    'f-type': 'f-type',
    'i-pace': 'i-pace',
    's-type': 's-type',
    'x-type': 'x-type',
    'xfr-s': 'xfr-s',
    'xjr-s': 'xjr-s',
    'xkr-s': 'xkr-s',
    'cx-3': 'cx-3',
    'cx-30': 'cx-30',
    'cx-5': 'cx-5',
    'cx-7': 'cx-7',
    'mx-3': 'mx-3',
    'mx-30': 'mx-30',
    'mx-5': 'mx-5',
    'mx-5-rf': 'mx-5 rf',
    'rx-7': 'rx-7',
    'rx-8': 'rx-8',
    'zt-t': 'zt-t',
    'i-miev': 'i-miev',
    'gt-r': 'gt-r',
    'x-trail': 'x-trail',
    'gen-2': 'gen-2',
    '9-3': '9-3',
    '9-3x': '9-3x',
    '9-5': '9-5',
    'sx4-s-cross': 'sx4 s-cross',
    'x-90': 'x-90',
    'c-hr': 'c-hr',
    't-cross': 't-cross',
    't-roc': 't-roc'
  }
};

export const transformMake = (urlMake: string): string => {
  if (mapping.makes[urlMake]) {
    return mapping.makes[urlMake];
  } else {
    return urlMake.replace(/-/g, ' ');
  }
};

export const transformModel = (urlModel: string): string => {
  if (mapping.models[urlModel]) {
    return mapping.models[urlModel];
  } else {
    return urlModel.replace(/-/g, ' ');
  }
};



// WEBPACK FOOTER //
// ./src/Results/buildQuery/mapping.js